import { Component, HostBinding, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SafePipe } from '@agingplan';
import { SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-one-side-page',
  templateUrl: './one-side-page.component.html',
  styleUrls: ['./one-side-page.component.scss']
})
export class OneSidePageComponent {

  /**
   * Set the background image
   */
  @HostBinding('style') backgroundImage: SafeStyle | undefined;

    /**
     * CSS classes to be applied for landingpage component
     */
    @Input() landing_class = '';

  public logo: string = `${environment.google.bucket}/assets/agingplan/logo/AgingPlan_DarkBackground.svg`;

  constructor(private safePipe: SafePipe) {
    // Set Background Image
    const path = `${environment.google.bucket}/assets/linen-texture/Linen_Black.png`;
    this.backgroundImage = this.safePipe.transform(`background-image: url('${path}')`, 'style')
  }

}
